export {
  default as apple,
  ReactComponent as Apple,
} from '@assets/thirdParty/apple.svg'    
